<template>
    <div class="sa-tab-scroll">
        <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
            <!-- <div class="sa-list-component-header">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div> -->
            <div class="sa-list-component-body">
                <div class="b-table-sticky-header">
                    <b-button v-if="btnEditViible" size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAggiungi" class="mb-2">
                        <i class="fas fa-plus"></i>
                        Aggiungi
                    </b-button>
                    <b-table sticky-header ref="table" stacked="sm" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(createDate)="{ item }">
                            {{ formatDateTime(item.createDate) }}
                        </template>
                        <template v-slot:cell(utente)="{ item }">
                            <span class="sa-label-data-secondary">{{ item.firstname }} {{ item.lastname }}</span>
                            <span class="sa-label-data-secondary">{{ item.denominazioneStruttura }}</span>
                        </template>
                        <template #cell(action)="{ item }">
                            <b-button size="sm" variant="btn btn-outline-secondary waves-effect waves-light width-sm no-tex" @click="onVisualizza(item)">
                                <font-awesome-icon icon="eye" />
                            </b-button>
                            <b-button size="sm" variant="btn btn-outline-info waves-effect waves-light width-sm no-text" @click="onVisualizzaPdf(item)">
                                <i class="bi bi-filetype-pdf"></i>
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
        <!-- <b-modal scrollable b-modal ref="mdlSchedeValutazioneIda" id="mdlSchedeValutazioneIda" size="xl" style="height: 100%" @ok="onAddScheda" :title="'Scheda: ' + rigaSelezionata.tipoScheda">
      <cot-scala-brass-ida-component @update="onUpdateScheda"></cot-scala-brass-ida-component>
    </b-modal>
    <b-modal scrollable b-modal ref="mdlSchedeValutazioneMews" id="mdlSchedeValutazioneMews" size="xl" style="height: 100%" @ok="onAddScheda" :title="'Scheda: ' + rigaSelezionata.tipoScheda">
      <cot-scala-mews-component @update="onUpdateScheda"></cot-scala-mews-component>
    </b-modal> -->
        <pdf-print-view-embedded ref="pdfPrintViewEmbedded" :pdf="signedPdfViewer"></pdf-print-view-embedded>
        <cot-proposta-accesso-proroghe-modal-edit-component ref="cmpCotPropostaAccessoProrogheModalEdit" @saveSuccess="onSaveSuccess"></cot-proposta-accesso-proroghe-modal-edit-component>
        <cot-proposta-accesso-proroghe-modal-view-component ref="cmpCotPropostaAccessoProrogheModalView"></cot-proposta-accesso-proroghe-modal-view-component>
    </div>
</template>

<script>
import axios from "axios";
import PdfPrintViewEmbedded from "../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import CotPropostaAccessoProrogheModalEditComponent from "./CotPropostaAccessoProrogheModalEditComponent.vue";
import CotPropostaAccessoProrogheModalViewComponent from "./CotPropostaAccessoProrogheModalViewComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: { PdfPrintViewEmbedded, CotPropostaAccessoProrogheModalEditComponent, CotPropostaAccessoProrogheModalViewComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            idPropostaAccesso: "",
            pathResource: "/cotrichiesteproroga",
            pathResourceStampa: "/print/createreport",
            signedPdfViewer: null,
            btnEditViible: false,
            filtro: {},
            items: [],
            rigaSelezionata: {},
            nomeModal: "",
            scheda: { id: "-1" },
            listKey: 0,
            fields: [
                {
                    label: "Data Richiesta",
                    key: "createDate",
                    sortable: true,
                },
                {
                    label: "Giorni Proroga",
                    key: "numeroGiorni",
                    sortable: true,
                },
                {
                    label: "Utente",
                    key: "utente",
                    sortable: true,
                },
                {
                    label: "",
                    key: "action",
                    thStyle: "width: 10rem",
                },
            ],
        };
    },
    created() {
        let me = this;
        me.btnEditViible = UtilityMixin.methods.verificaPermessiByIdSezionePermesso("cotproroga", 2);
    },
    mounted() {
        let me = this;
        me.btnEditViible = UtilityMixin.methods.verificaPermessiByIdSezionePermesso("cotproroga", 2);
    },
    methods: {
        onSaveSuccess() {
            let me = this;
            me.loadData();
        },
        onClickAggiungi() {
            let me = this;
            me.$refs.cmpCotPropostaAccessoProrogheModalEdit.init(null, me.idPropostaAccesso);
        },
        init(id) {
            let me = this;
            me.idPropostaAccesso = id;
            me.loadData();
        },
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            me.filtro.idCot = me.idPropostaAccesso;
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.items = [];
                    me.items = response.data.data.list;
                    me.rows = response.data.data.recordsNumber;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onPrint() {
            console.log("Eccomi");
        },
        onModifica() {
            console.log("Modifica");
        },
        onVisualizza(value) {
            let me = this;
            me.$refs.cmpCotPropostaAccessoProrogheModalView.init(value.id);
        },
        onAddScheda() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.rigaSelezionata.path;
            if (me.scheda.id === "-1") {
                me.scheda.id = null;
                me.scheda.idPropostaAccesso = me.idPropostaAccesso;
                axios
                    .post(link, JSON.stringify(me.scheda))
                    .then(() => {
                        me.$refs[me.nomeModal].hide();
                        this.$bvToast.toast("Salvataggio avvenuto con successo", {
                            title: this.titleModal,
                            variant: "success",
                            autoHideDelay: 1000,
                        });
                        me.loadData();
                    })
                    .catch((error) => {
                        me.showModalLoading = false;
                        this.$bvModal
                            .msgBoxOk(error.response.data.messaggio, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerClass: "sa-msg-header-danger",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                            .then((value) => {
                                this.boxTwo = value;
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    });
            } else {
                link = link + "/" + me.scheda.idPropostaAccesso;
                axios
                    .put(link, JSON.stringify(me.scheda))
                    .then(() => {
                        me.$refs[me.nomeModal].hide();
                        this.$bvToast.toast("Salvataggio avvenuto con successo", {
                            title: this.titleModal,
                            variant: "success",
                            autoHideDelay: 1000,
                        });
                        me.loadData();
                    })
                    .catch((error) => {
                        me.showModalLoading = false;
                        this.$bvModal
                            .msgBoxOk(error.response.data.messaggio, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerClass: "sa-msg-header-danger",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                            .then((value) => {
                                this.boxTwo = value;
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    });
            }
        },
        onUpdateScheda(data) {
            let me = this;
            me.scheda = data;
        },
        onVisualizzaPdf(value) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/print/" + value.id;
            axios.get(link).then((response) => {
                let printData = response.data.data;
                let linkReport = process.env.VUE_APP_PATH_API + me.pathResourceStampa;
                axios.post(linkReport, printData).then((response) => {
                    me.$refs.pdfPrintViewEmbedded.show();
                    me.signedPdfViewer = "data:application/pdf;base64," + response.data.base64;
                });
            });
        },
    },
};
</script>

<style></style>
